<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'nuxt/app'

  import { isCPPublicCheckoutRoutePath } from '@clientportal/routing-layer/constants/auth.constants'
  import { isCPAuthRoutePath } from '@clientportal/routing-layer/utils/auth-route.utils'

  const CPRootContainer = defineAsyncComponent(() => import('./components/CPRootContainer.vue'))

  const route = useRoute()

  const isStandaloneCpShellRoute = computed(() => {
    const standaloneFromRouteMeta = Boolean(route.meta?.standaloneCpShell)
    const standaloneFromMatchedMeta = route.matched?.some(record => record.meta?.standaloneCpShell === true) ?? false
    const standaloneFromPath = isCPPublicCheckoutRoutePath(route.path)
    return standaloneFromRouteMeta || standaloneFromMatchedMeta || standaloneFromPath
  })

  const layoutBoundaryKey = computed(() => (isCPAuthRoutePath(route.path) ? 'auth' : 'portal'))
</script>

<template>
  <NuxtPage v-if="isStandaloneCpShellRoute" />
  <CPRootContainer v-else>
    <NuxtLayout :key="layoutBoundaryKey">
      <NuxtPage />
    </NuxtLayout>
  </CPRootContainer>
</template>
